<template>
<div class="chapter">
<div class="inner_page">
<p class="image-center"><img alt="CONTENTS" src="images/content.jpg"/></p>
<p class="normal mtop1 mleft"><a href="#/f007"><span class="no-style-override-32">Acknowledgments </span></a></p>
<p class="normal mtop mleft"><a href="#/f008"><span class="no-style-override-32">Harvey Louis Carignan </span></a></p>
<p class="normal mtop mleft"><a href="#/f009"><span class="no-style-override-32">Arthur John Shawcross </span></a></p>
<p class="normal mtop mleft"><span href="#/f010" title="Link target outside of Sample"><span class="no-style-override-32">John Martin Scripps </span></span></p>
<p class="normal mtop mleft"><span href="#/f011" title="Link target outside of Sample"><span class="no-style-override-32">Michael Bruce Ross</span></span></p>
<p class="normal mtop mleft"><span href="#/f012" title="Link target outside of Sample"><span class="no-style-override-32">Ronald Joseph ‘Butch’ DeFeo Jr</span>.</span></p>
<p class="normal mtop mleft"><span href="#/f013" title="Link target outside of Sample"><span class="no-style-override-32">Aileen Carol Wuornos </span></span></p>
<p class="normal mtop mleft"><span href="#/f014" title="Link target outside of Sample"><span class="no-style-override-32">Kenneth Allen McDuff </span></span></p>
<p class="normal mtop mleft"><span href="#/f015" title="Link target outside of Sample"><span class="no-style-override-32">Douglas Daniel Clark &amp; Carol </span><span class="no-style-override-33">Mary Bundy </span></span></p>
<p class="normal mtop mleft"><span href="#/f016" title="Link target outside of Sample"><span class="no-style-override-32">Henry Lee Lucas</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f006.vue?0e33637a